import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ValuatForStartups from './ValuatForStartups';
import './styles.scss';

function PublicForm({ title, className = '', children }) {
  useEffect(() => {
    const $main = document.querySelector('main');
    $main.classList.add('public-form');

    return () => {
      $main.classList.remove('public-form');
    };
  }, []);

  return (
    <>
      <ValuatForStartups />
      <div className={`form-wrapper ${className}`}>
        <div className='form-box'>
          <div className='form-header'>{title}</div>
          {children}
        </div>
      </div>
    </>
  );
}

PublicForm.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PublicForm;
